import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { OPTIONAL } from '../../constants/constant';

@Component({
  selector: 'app-input-radio-btns',
  templateUrl: './input-radio-btns.component.html',
  styleUrls: ['./input-radio-btns.component.scss', '../input-textbox/input-textbox.component.scss']
})
export class InputRadioBtnsComponent implements OnInit {

  @Input() labelName: string;
  @Input() inputFormControl: FormControl;
  @Input() submitted = false;
  @Input() disableComments = false;
  @Input() readOnlyMode = false;
  @Input() showCommentIcon = false;
  @Input() commentObject: FormControl;
  @Input() radioBtnName: string;
  @Input() tooltiptxt: string;
  @Input() labelTextTransformNone = false;
  @Input() showOptionalLabel = true;
  @Output() onShowComment = new EventEmitter();

  OPTIONAL = OPTIONAL;

  constructor() { }

  ngOnInit(): void {
  }

  get isRequiredField(): boolean {
    if (!this.inputFormControl || !this.inputFormControl.validator) {
      return false;
    }

    const validator = this.inputFormControl.validator({} as AbstractControl);
    return (validator && validator.required);
  }

  getClasses(): string {
    if (this.inputFormControl &&
      (this.submitted || this.inputFormControl.touched) &&
      this.inputFormControl.errors) {
      if (this.showCommentIcon) {
        return 'error-input show-comment-input';
      }
      return 'error-input';
    } else {
      if (this.showCommentIcon) {
        return 'show-comment-input';
      }
      return '';
    }
  }

}
